var exports = {
  "kL": "xe564cbfb--a404d0--container",
  "VE": "xe564cbfb--a404d0--visually-hidden",
  "Qs": "xe564cbfb--a404d0--content",
};

module.exports = exports;
